import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Row, Select, Col, Button, Form, Pagination,Input } from "antd";
import "@liepin/antd-city-pc/lib/index.less";
import ajax from "../../utils/ajax";
import { filterComps } from "./dataConfig";
import "./index.less";
const successIds = `13223897
9377067
8040756
7856188
8532100
12250035
8557151
13716797
8296610
8043920
9135893
8464948
8435236
2628866
13240295
13326337
13157905
9516092
7921306
9244705
13716797
13443149
8304674
12914205
8173716
9167350
12254849
8914807
8183821
12439701
12304591
7984762
9873003
8360675
12369067
7958488
12525113
13036559`.split(/\n/g).map(it=>it.replace(/\s/g,''))
export default (props) => {
  const [form] = Form.useForm();
  const [companyListRes, setCompanyListRes] = useState([]);
  const [next, setNext] = useState(true);
  const [total, setTotal] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [listRows] = useState(3);
  const [companyList, setCompanyList] = useState([]);
  const [intruduceName, setIntruduceName] = useState('船舶海工产业');

  const getAllCompanyList = (array) => {
    let totalLength = 0;
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < array[i].length; j++) {
        totalLength += 1;
      }
    }
    return totalLength;
  };

  const splitArray = (groupSize, originArray) => {
    const groups = [];
    for (let i = 0; i < originArray.length; i += groupSize) {
      const group = originArray.slice(i, i + groupSize);
      groups.push(group);
    }
    return groups;
  };

  const getData = (data) => {
    const {
      curPage = 0,
      isInit = false,
      companyList,
      compKinds,
      compScales,
      dqCodes4comp,
      keyWords
    } = data || {};
    if (curPage >= 100) {
      setNext(false);
    }

    if (!next && !isInit) return;
    // 初始化请求，先请求5页的数据， 用于快速点击跳转
    // 服务端接口不再有totalCount值，需要使用next来判断是否有下一页
    const params = { curPage, pageSize: (listRows || 3) * 4 };
    if (isInit) {
      params.pageSize = (listRows || 3) * 4 * 5;
      setNext(true);
    }
    const inputVo = {
      comps: companyList.filter(it=>successIds.includes(String(it.compId))),
      modelType: "1",
      jobNum: 1,
      showCompTag: true,
      showJobs: true,
      sortType: "1",
      compKinds: compKinds?.length ? compKinds : [],
      keyWords,
      compTags: [],
      payType: [],
      lightSpots: [],
      dqCodes4comp: dqCodes4comp?.length ? dqCodes4comp : [],
      workTime: [],
      industries: [],
      compStages: [],
      compScales: compScales?.length ? compScales : [],
      searchType: "2", // 上传企业:2 全量企业:1
      dqCodes4job: [],
      userMatch: false,
      showCompDesc: true,
    };

    params.inputVo = JSON.stringify(inputVo);

    ajax
      .post(
        "https://api-wanda.liepin.com/api/com.liepin.rivers.newcomp.v1.get-card",
        params
      )
      .then(({ data, traceId }) => {
        const { list } = data;
        const tmpList =
          list?.length > 0
            ? list.map((compInfo) => {
                return {
                  ...compInfo,
                };
              })
            : [];

        if (tmpList.length < params.pageSize) {
          setNext(false);
        }

        if (isInit) {
          const companyListRes = splitArray((listRows || 3) * 4, tmpList);
          const total = tmpList.length;
          const curPage = 0;
          setCompanyListRes(companyListRes);
          setTotal(total);
          setCurPage(curPage);
        } else {
          setCompanyListRes([...companyListRes, tmpList]);
          const newTotal = getAllCompanyList(companyListRes) + tmpList.length;
          setTotal(newTotal);
        }
      });
  };
  const handlePageSize = (curPage) => {
    // const { companyListRes, getData, change } = this.store;
    setCurPage(curPage - 1);
    if (!companyListRes[curPage - 1]) {
      getData({
        curPage: curPage - 1,
      });
    }

    if (!companyListRes[curPage]) {
      getData({
        curPage: curPage,
      });
    }
  };
  const handleSubmit = (value) => {
    console.log(value);
    getData({ isInit: true, companyList, ...value });
  };
  const handleChange = (e) => {
    getData({ isInit: true, companyList, ...{keyWords: e.target.value} });
  };
  const delFilterComps = useMemo(() => {
    const sortArr = [
      "船舶海工产业",
      "高端纺织产业",
      "高端装备产业",
      "新材料产业",
      "新能源产业",
      "新一代信息技术产业"
    ];
    const newFilterComps = filterComps.map((item) => {
      item.comps = item.comps.map((comp) => {
        return { compId: comp };
      });
      return item;
    });
    newFilterComps.forEach((item) => {
      let indx = sortArr.indexOf(item.name);
      sortArr[indx] = item;
    });
    return sortArr;
  }, []);
  useEffect(() => {
    setCompanyList(delFilterComps[0].comps);
    getData({ isInit: true, companyList: delFilterComps[0].comps });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getUrl = (url) => {
    return url.replace(
      /((https?)?\/\/image0.lietou-static.com\/img\/?)?(.*)$/,
      "//image0.lietou-static.com/img/$3"
    );
  };
  const handleChangeTab = (comps, indx,name) => {
    props.handelName(name)
    form.resetFields();
    setCompanyList(comps);
    getData({ isInit: true, companyList: comps });
    setActiveTab(indx);
    setIntruduceName(name);
  };
  const compCardList = useMemo(() => {
    return companyListRes[curPage]?.length
      ? splitArray(4, companyListRes[curPage])
      : [];
  }, [companyListRes, curPage]);
  // console.log(total, compCardList);
  return (
    <div className="hot-comp-container-out">
      <div className="hot-tab">
        {delFilterComps.map((comp, indx) => {
          // return (
          //   <div
          //     className={activeTab === indx ? "tab active" : "tab"}
          //     key={indx}
          //     onClick={() => handleChangeTab(comp.comps, indx,comp.name)}
          //   >
          //     {comp.name}
          //   </div>
          // );
          return (
            <img src={activeTab === indx ? comp.urlActive : comp.url} key={indx} onClick={() => handleChangeTab(comp.comps, indx,comp.name)}/>
          );
        })}
      </div>
      <div className="hot-comp-container">
        <div className="comp-content">
          <Form key="qa2" onFinish={handleSubmit} layout="inline" form={form}>
            <Form.Item name="keyWords">
              <Input placeholder="请输入职位名称或公司名称搜索" onChange={handleChange} style={{width:'calc(100vw / 1920 * 707)'}}/>
            </Form.Item>
          </Form>
          {total > 0 ? (
            <div className="comp-card-container">
              {compCardList.map((result, i) => {
                return (
                  <Row gutter={18} style={{ marginBottom: "10px" }} key={i}>
                    {result.map((item, j) => {
                      return (
                        <Col
                          className="gutter-row"
                          span={6}
                          key={item.compId + j}
                        >
                          <div className="comp-card">
                            <a href={item.compUrl}>
                              <div className="img-container">
                                <img src={getUrl(item.compLogo)} alt=""></img>
                              </div>
                            </a>
                            <div className="company-name-container">
                              <span className="company-name" title={item.companyName}>
                                {item.companyName}
                              </span>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                );
              })}
            </div>
          ) : (
            <div className="search-companyList-empty">
              这里没有更多啦，换个筛选条件试试吧
            </div>
          )}
          {total > 0 && total > listRows * 4 ? (
            <div className="search-pagination">
              <Pagination
                current={curPage + 1}
                total={total}
                showLessItems
                pageSize={listRows * 4}
                onChange={handlePageSize}
                showSizeChanger={false}
              />
            </div>
          ) : null}
        </div>
      </div>
      
    </div>
  );
};
